module.exports = __webpack_public_path__ + "img/roadmap-bubble-3.92b86c15.svg";